var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75837 1.18332L1.51254 2.93332C1.13754 3.22499 0.833374 3.84582 0.833374 4.31665V7.40415C0.833374 8.37082 1.62087 9.16249 2.58754 9.16249H7.41254C8.37921 9.16249 9.16671 8.37082 9.16671 7.40832V4.37499C9.16671 3.87082 8.82921 3.22499 8.41671 2.93749L5.84171 1.13332C5.25837 0.724986 4.32087 0.74582 3.75837 1.18332Z",
    stroke: "#5A6F7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.49585V6.24585",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.144ebcefcc1eae005084a5bf3f91413d.svg";
export { ForwardRef as ReactComponent };